 $(document).on('click', '.stylist-trigger', function () {

    var _this = $(this);

    var stylist = _this.attr('data-stylist-trigger'); 

    if (_this.hasClass('current')) {
        return;
    } else {
          
        $('.stylist-trigger').removeClass('current');
        $('.stylist-target').removeClass('current'); 

        _this.addClass('current');
        var targets = $('[data-stylist-target="' + stylist + '"]');
        targets.addClass('current');

        setTimeout(function () {
            targets.find('.widget-carousel-news-feed').flickity('resize');

            var ellipsisEl = targets.find('.ellipsis-new');
            if (ellipsisEl.length) {
                ellipsisEl.each(function () {
                    var _this = $(this);
                    _this.trigger('destroy').removeAttr('style');
                    setTimeout(function () {
                        ellipsisNew.applyEllipsis(_this);
                    }, 50);
                });
            }
        }, 50);
    }

});